import { render, staticRenderFns } from "./Moneystatistics.vue?vue&type=template&id=7487fd8a&scoped=true&"
import script from "./Moneystatistics.vue?vue&type=script&lang=js&"
export * from "./Moneystatistics.vue?vue&type=script&lang=js&"
import style0 from "./Moneystatistics.vue?vue&type=style&index=0&id=7487fd8a&scoped=true&lang=css&"
import style1 from "./Moneystatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7487fd8a",
  null
  
)

export default component.exports